import { render, staticRenderFns } from "./RedeemPoint.vue?vue&type=template&id=2c5c374c&scoped=true&"
import script from "./RedeemPoint.vue?vue&type=script&lang=js&"
export * from "./RedeemPoint.vue?vue&type=script&lang=js&"
import style0 from "./RedeemPoint.vue?vue&type=style&index=0&id=2c5c374c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c374c",
  null
  
)

export default component.exports